interface PartBoxImageProps {
  isBoxLayout: boolean;
  color?: string;
  imageSrc?: string;
}

const PartBoxImage: React.FC<PartBoxImageProps> = ({
  isBoxLayout,
  color,
  imageSrc,
}) => {
  const bgColorIsUrl = color
    ? color.startsWith("http://") || color.startsWith("https://")
    : false;
  const colorStyles = bgColorIsUrl
    ? { backgroundImage: `url(${color})` }
    : { backgroundColor: color };

  if (isBoxLayout && color) {
    return <div className="box-bg-color" style={colorStyles}></div>;
  }

  if (isBoxLayout && imageSrc) {
    return <img src={imageSrc} />;
  }
  return null;
};
export default PartBoxImage;
